module.exports = __webpack_public_path__ + "static/media/icons_Bilan AVC - H‚mipl‚gie.1baec794.svg";